module.exports = __webpack_public_path__ + "static/media/r_dot_9.af617b10.png";